// "I've seen this scan" — persisted per account + workspace + RUN identity (v3
// `recommendationDismissKey`). Keyed on the identity rather than on the workspace alone so
// dismissing today's scan does not also hide tomorrow's.
//
// Plain `localStorage`, deliberately: the value is a single boolean flag about UI state, carries
// nothing about the user, and v3's key format is preserved so a dismissal made before the cutover
// still reads back afterwards. Every access is best-effort — a browser with storage disabled must
// dismiss for the page session and move on, never throw.

const PREFIX = 'impact-analysis:recommendations-dismissed'

export interface DismissalScope {
  accountId: number | string
  workspaceId: number | string
}

function key(scope: DismissalScope, identity: string): string {
  return `${PREFIX}:${scope.accountId}:${scope.workspaceId}:${identity}`
}

export const recommendationDismissal = {
  isDismissed(scope: DismissalScope, identity: string): boolean {
    try {
      return window.localStorage.getItem(key(scope, identity)) === '1'
    } catch {
      return false
    }
  },

  dismiss(scope: DismissalScope, identity: string): void {
    try {
      window.localStorage.setItem(key(scope, identity), '1')
    } catch {
      // Persistence is best-effort; the dismissal still applies for this page session.
    }
  },
}
